import { useState } from "react";
import { RefObject } from "react";
import { useActivityTracker } from "../../hooks/useActivityTracker";

import ContactModal from "../CTA/ContactModal";
import ConsultationModal from "./ConsultationModal";

interface CTASectionProps {
  ctaRef?: RefObject<HTMLDivElement | null>;
}

export default function CTASection({ ctaRef }: CTASectionProps) {
  const [contactOpen, setContactOpen] = useState(false);
  const [consultOpen, setConsultOpen] = useState(false);

  // ✅ Initialize hook at top
  const { trackActivity } = useActivityTracker();

  const handleContactClick = () => {
    setContactOpen(true);
    trackActivity(
      "CTA_Click",
      "CTA Section - Contact Us",
      "User clicked Contact Us button in CTA section"
    );
  };

  const handleConsultClick = () => {
    setConsultOpen(true);
    trackActivity(
      "CTA_Click",
      "CTA Section - Request Consultation",
      "User clicked Request Consultation button in CTA section"
    );
  };

  return (
    <>
      <section
        ref={ctaRef}
        id="cta-section"
        className="bg-gradient-to-r from-blue-800 to-blue-600 pt-4 py-4 text-center text-white"
      >
        <h2 className="text-2xl font-bold">
          Have a Question or Need Guidance?
        </h2>

        <p className="mt-4 text-blue-100">
          Contact us for general inquiries or request a consultation to speak
          with our experts.
        </p>

        <div className="mt-4 flex justify-center gap-4">
          <button
            onClick={handleContactClick}
            className="
              rounded-md bg-white px-6 py-3 text-sm font-semibold text-blue-700
              transition-all duration-200
              hover:-translate-y-1 hover:scale-105 hover:shadow-md
            "
          >
            Contact Us
          </button>

          <button
            onClick={handleConsultClick}
            className="
              rounded-md border border-white/30 px-6 py-3 text-sm font-semibold text-white
              transition-all duration-200
              hover:-translate-y-1 hover:scale-105 hover:shadow-md
            "
          >
            Request Consultation
          </button>
        </div>
      </section>

      <ContactModal
        isOpen={contactOpen}
        onClose={() => setContactOpen(false)}
      />

      <ConsultationModal
        isOpen={consultOpen}
        onClose={() => setConsultOpen(false)}
      />
    </>
  );
}